module.exports = __webpack_public_path__ + "img/av249.f2bbac70.png";